import { render } from "./VeiculosVendidoEstoque.vue?vue&type=template&id=b9ba64f0"
import script from "./VeiculosVendidoEstoque.vue?vue&type=script&lang=js"
export * from "./VeiculosVendidoEstoque.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__